export default __webpack_public_path__ + "static/media/excelClearGray.16b77cd2.svg";